// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rq-0";